import { combineReducers } from "@reduxjs/toolkit";
import * as reducers from "../../../entities";

export const rootReducer = combineReducers({
  auth: reducers.authReducer,
  confirm: reducers.confirmReducer,
  layout: reducers.layoutReducer,
  notification: reducers.notificationReducer,
});
